import { FILE_TYPE } from 'variables/constants';

const getFileType092 = (validations: Validation[]) => {
  const validation = validations.find((v) => v.validation_id === '092');
  const requiresPhotosOnly =
    validation?.validation_outcome_data?.requires_file === true;

  return requiresPhotosOnly
    ? FILE_TYPE.TYPE_092_110_PHOTOS_ONLY
    : FILE_TYPE.TYPE_092_110;
};

export default getFileType092;
